var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7575_6981",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7575_6981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8334 70.8334H54.1667V45.8334H45.8334V70.8334ZM50 37.5C51.1806 37.5 52.1702 37.1007 52.9688 36.3021C53.7674 35.5035 54.1667 34.5139 54.1667 33.3334C54.1667 32.1528 53.7674 31.1632 52.9688 30.3646C52.1702 29.566 51.1806 29.1667 50 29.1667C48.8195 29.1667 47.8299 29.566 47.0313 30.3646C46.2327 31.1632 45.8334 32.1528 45.8334 33.3334C45.8334 34.5139 46.2327 35.5035 47.0313 36.3021C47.8299 37.1007 48.8195 37.5 50 37.5ZM50 91.6667C44.2361 91.6667 38.8195 90.573 33.75 88.3855C28.6806 86.198 24.2709 83.2292 20.5209 79.4792C16.7709 75.7292 13.8021 71.3195 11.6146 66.25C9.42711 61.1806 8.33336 55.7639 8.33336 50C8.33336 44.2362 9.42711 38.8195 11.6146 33.75C13.8021 28.6806 16.7709 24.2709 20.5209 20.5209C24.2709 16.7709 28.6806 13.8021 33.75 11.6146C38.8195 9.42712 44.2361 8.33337 50 8.33337C55.7639 8.33337 61.1806 9.42712 66.25 11.6146C71.3195 13.8021 75.7292 16.7709 79.4792 20.5209C83.2292 24.2709 86.1979 28.6806 88.3854 33.75C90.5729 38.8195 91.6667 44.2362 91.6667 50C91.6667 55.7639 90.5729 61.1806 88.3854 66.25C86.1979 71.3195 83.2292 75.7292 79.4792 79.4792C75.7292 83.2292 71.3195 86.198 66.25 88.3855C61.1806 90.573 55.7639 91.6667 50 91.6667Z",
    fill: "#E80004"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRed);
export default __webpack_public_path__ + "static/media/info_red.2215fdc1424d298e253eb3acaa36bd2f.svg";
export { ForwardRef as ReactComponent };